import { request } from "hooks/useOkoApi/useOkoApi";

const STORAGE_PREFIX = "oko_filters_";
const SHARED_KEY = STORAGE_PREFIX + "shared";
export const saveFilters = (pageKey, filters) => {
  try {
    localStorage.setItem(STORAGE_PREFIX + pageKey, JSON.stringify(filters));
    // Also persist shared fields so other tabs can pick them up.
    // Merge with the existing shared snapshot so pages that don't know about
    // certain fields (e.g. Proficiency doesn't pass student/standard) don't
    // clobber values set by pages that do (Student Activity, Session History).
    const classId = filters.selectedClassId || filters.classroomId;
    if (classId) {
      const existing = loadSharedFilters() || {};
      const classChanged =
        existing.selectedClassId && existing.selectedClassId !== classId;
      // If the class itself changed, stale student/standard no longer apply.
      const shared = classChanged
        ? { selectedClassId: classId }
        : { ...existing, selectedClassId: classId };

      if ("selectedStudentId" in filters || "studentId" in filters) {
        const studentId = filters.selectedStudentId || filters.studentId || null;
        if (studentId) shared.selectedStudentId = studentId;
        else delete shared.selectedStudentId;
      }

      if ("selectedStandard" in filters || "standardCode" in filters) {
        const standard = filters.selectedStandard || filters.standardCode || null;
        if (standard) {
          shared.selectedStandard = standard;
          shared.standardDisplayLabel = filters.standardDisplayLabel || null;
        } else {
          delete shared.selectedStandard;
          delete shared.standardDisplayLabel;
        }
      }

      localStorage.setItem(SHARED_KEY, JSON.stringify(shared));
    }
  } catch (e) {
    // localStorage may be unavailable
  }
};

export const loadSharedFilters = () => {
  try {
    const stored = localStorage.getItem(SHARED_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    return null;
  }
};

export const clearAllFilters = () => {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(STORAGE_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    // localStorage may be unavailable
  }
};

export const loadFilters = (pageKey) => {
  try {
    const stored = localStorage.getItem(STORAGE_PREFIX + pageKey);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    return null;
  }
};

export const resolveClassId = async (pageKey, classList) => {
  const saved = loadFilters(pageKey);
  // 1. Check shared filters first — always reflects the most recent user selection
  const shared = loadSharedFilters();
  if (shared?.selectedClassId && classList.some(c => c.id === shared.selectedClassId)) {
    const mergedSaved = shared.selectedClassId === saved?.selectedClassId ? saved : null;
    return { classId: shared.selectedClassId, saved: mergedSaved, shared };
  }
  // 2. Fall back to this tab's own saved filters
  if (saved?.selectedClassId && classList.some(c => c.id === saved.selectedClassId)) {
    return { classId: saved.selectedClassId, saved };
  }
  // 3. Fall back to latest session
  try {
    const latestSession = await request("account/latest_session", { method: "GET" });
    if (latestSession?.classroom_id && classList.some(c => c.id === latestSession.classroom_id)) {
      return { classId: latestSession.classroom_id, saved: null };
    }
  } catch (e) {
    // fall through to default
  }
  return { classId: classList[0].id, saved: null };
};
